import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DevicesIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M14.5 13.5H9.5M5.5 13.5752V13.5M2 12.5L3.67845 4.10777C3.86542 3.17292 4.68625 2.5 5.63961 2.5H13.9203C14.8464 2.5 15.6514 3.13582 15.8659 4.03676L18 13M14.0003 9.5H6.00013C3.79094 9.5 2.00006 11.2909 2.00013 13.5001C2.0002 15.7092 3.79104 17.5 6.00013 17.5H14.0003C16.2094 17.5 18.0003 15.7091 18.0003 13.5C18.0003 11.2909 16.2094 9.5 14.0003 9.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DevicesIcon.displayName = 'DevicesIcon';
